// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"1f4ca076","198":"2e507008","498":"bc992d33","666":"bdbca867","685":"5da45438","949":"a1884609"}[chunkId] + ".chunk.js";
};